<template>
    <div>
        <portal to="page-header">{{ $t('Deposit') }} {{ $t('for') }} {{ player.username }}</portal>

        <portal to="actions">
            <back-button
                :route-name="'players.show'"
                :route-param="player.id"
            >{{ $t('Details') }}</back-button>
        </portal>

        <form @submit.prevent="submit">
            <div class="flex flex-wrap">
                <div class="sm:px-1 md:px-3 lg:px-3 xl:px-3 w-full">
                    <card>
                        <div class="flex w-full">
                            <div class="px-4 py-2 w-1/2 sm:w-1/4">
                                <h4 class="font-normal text-gray-500 mt-2">{{ $t('Username') }}</h4>
                            </div>
                            <div class="py-2 px-4 w-1/2 sm:w-3/4">
                                <p class="">{{ player.username }}</p>
                            </div>
                        </div>
                        <div class="flex w-full">
                            <div class="px-4 py-2 w-1/2 sm:w-1/4">
                                <h4 class="font-normal text-gray-500 mt-2">{{ $t('Balance') }}</h4>
                            </div>
                            <div class="py-2 px-4 w-1/2 sm:w-3/4">
                                <p class="">{{ showFormattedAmount(balance, player.main_wallet.currency.code) }}</p>
                            </div>
                        </div>
                        <div v-for="(value, banknote) of banknotes" class="flex field-wrapper w-full">
                            <div class="px-4 py-2 w-1/2 sm:w-1/4">
                                <label :for="`banknote-${banknote}`" class="inline-block text-gray-500 pt-2 leading-tight">
                                    {{  banknote }}
                                </label>
                            </div>
                            <div class="py-2 px-4 w-1/2 sm:w-3/4">
                                <plus-minus-field
                                    id="`banknote-${banknote}`"
                                    :min="0"
                                    :banknote="parseInt(banknote)"
                                    @input="banknotesCount" />
                            </div>
                        </div>
                        <div class="flex field-wrapper w-full">
                            <div class="px-4 py-2 w-1/2 sm:w-1/4">
                                <label for="amount" class="inline-block text-gray-500 pt-2 leading-tight">
                                    {{ $t('Amount') }}
                                </label>
                            </div>
                            <div class="py-2 px-4 w-1/2 sm:w-3/4">
                                <JetInput
                                    id="amount"
                                    type="number"
                                    ref="amount"
                                    min="0.01"
                                    :max="depositLimit"
                                    step="0.01"
                                    maxlength="13"
                                    :placeholder="$t('Amount')"
                                    v-model="form.amount"
                                    class="w-full form-control form-input"
                                    autofocus
                                />
                                <JetInputError :message="errors.amount" class="mt-2" />
                            </div>
                        </div>
                    </card>
                </div>
            </div>

            <div class="sm:px-1 md:px-3 lg:px-3 xl:px-3 mt-4 flex justify-between items-center">
                <div class="max-w-md mr-4"></div>
                <btn :processing="form.processing" :type="'submit'">
                    {{ $t('Deposit') }}
                </btn>
            </div>
        </form>
    </div>
</template>

<script>
import JetInput from '@/Jetstream/Input';
import JetInputError from '@/Jetstream/InputError';

import PageHeader from '../../Components/PageHeader';
import Card from '../../Components/Card';
import BackButton from '../../Components/BackButton';
import Btn from '../../Components/Btn';
import PlusMinusField from '../../Components/PlusMinusField';

export default {
    name: "Deposit",
    components: {PlusMinusField, Btn, PageHeader, Card, BackButton, JetInput, JetInputError},
    props: {
        player: Object,
        balance: Number,
        errors: Object
    },
    metaInfo() {
        return {
            title: this.title
        }
    },
    computed: {
        title () {
            return `${this.$t('Deposit')} ${this.$t('for')} ${this.player.username}`;
        },
        confirm () {
            return this.$t('Are you sure you want to deposit - ');
        },
        depositLimit() {
            return window.globalDepositLimit;
        }
    },
    data() {
        return {
            form: {
                amount: null,
                processing: false
            },
            banknotes: {
                "10": 0,
                "50": 0,
                "100": 0,
                "1000": 0,
            },
        }
    },
    mounted() {
        this.$refs.amount.focus();
    },
    methods: {
        async submit() {
            this.processing = true;
            await this.$inertia.post(route('players.depositProcess', this.player.id).url(), this.form, {
                onBefore: () => confirm(this.confirm + `${this.$formatCurrency(this.form.amount, this.player.main_wallet.currency.code)}?`)
            });
            this.processing = false;
        },
        banknotesCount(val, banknote) {
            this.banknotes[banknote] = val;
        },
        showFormattedAmount(amount, currencyCode) {
            return this.$formatCurrency(amount, currencyCode);
        }
    },
    watch: {
        banknotes: {
            handler() {
                this.form.amount = Object.entries(this.banknotes).map((entry) => {
                    return entry[0] * entry[1];
                }).reduce((total, num) => {
                    return total + num;
                });
            },
            deep: true
        }
    },
}
</script>

<style scoped>

</style>
